import { Codec, JSONCodec, NatsConnection, RequestOptions } from 'nats.ws';

export class RpcError extends Error {
	data: any;

	constructor(message: string, data: any) {
		super(message);
		this.data = data;
	}
}

export class RpcClient {
	nats: NatsConnection;
	codec: Codec<any>;

	constructor(nats: NatsConnection) {
		this.nats = nats;
		this.codec = JSONCodec();
	}

	async request<T> (subject: string, data: any, options: RequestOptions & { deadline?: Date } = { timeout: 1000 }): Promise<T> {
		const { deadline, timeout, ...rest } = options;

		const msg = await this.nats.request(subject, this.codec.encode({
			data,
			deadline,
			timeout,
		}), { timeout, ...rest });

		const rsp = this.codec.decode(msg.data);
		if (rsp.error) {
			throw new RpcError(rsp.error, rsp.data);
		}

		return rsp.data;
	}
}

export { RpcClient as default };
